import { Home, MessageSquare, Users, Settings, Headphones, RefreshCw } from "lucide-react";

export default function BottomNav({ currentPage, setCurrentPage, metrics, canRelance, businessMode }) {

  const navItems = [
    { id: "home",     label: "Accueil",   icon: Home },
    { id: "messages", label: "Messages",  icon: MessageSquare },
    { id: "support",  label: "Support",   icon: Headphones },
    { id: "contacts", label: "Contacts",  icon: Users },
    ...(canRelance ? [{ id: "relances", label: "Relances", icon: RefreshCw }] : [
      { id: "settings", label: "Réglages", icon: Settings }
    ]),
  ];

  const badges = {
    messages: null,
    orders: metrics?.ordersPending || 0,
    support: metrics?.ticketsOpen || 0,
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around items-center py-2 z-50">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = currentPage === item.id;
        const badge = badges[item.id];
        return (
          <button
            key={item.id}
            onClick={() => setCurrentPage(item.id)}
            className="flex flex-col items-center gap-1 relative px-3 py-1"
          >
            <div className="relative">
              <Icon size={20} className={isActive ? "text-orange-600" : "text-gray-400"} />
              {badge > 0 && (
                <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium">
                  {badge}
                </span>
              )}
            </div>
            <span className={`text-xs ${isActive ? "text-orange-600 font-medium" : "text-gray-400"}`}>
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}